import { isLangLocale, type LangLocale } from '@myre/common-i18n';

import { type CookieService } from 'ngx-cookie-service';

import { COOKIE_PREFIX, cookieOptions } from './cookies.constants';

const LANG_COOKIE_VALIDITY_IN_YEARS = 1;

function langCookieName(cookieSuffix: string | undefined): string {
  return COOKIE_PREFIX + cookieSuffix;
}

/**
 * The language the viewer picked, as the shared cookie remembers it across the
 * Myre frontends of one environment; `undefined` when none was picked yet or
 * when the cookie names a locale the platform does not serve.
 */
export function getLangCookie(params: {
  cookieService: CookieService;
  cookieSuffix: string | undefined;
}): LangLocale | undefined {
  const { cookieService, cookieSuffix } = params;
  const lang = cookieService.get(langCookieName(cookieSuffix));

  if (isLangLocale(lang)) {
    return lang;
  }

  return;
}

/**
 * Remember the viewer's language for every Myre frontend of the environment:
 * the cookie is scoped to the environment domain and renewed for a year.
 */
export function setLangCookie(params: {
  lang: string;
  cookieService: CookieService;
  cookieSuffix: string | undefined;
  domain: string | undefined;
}): void {
  const { lang, cookieService, cookieSuffix, domain } = params;
  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + LANG_COOKIE_VALIDITY_IN_YEARS);

  cookieService.set(langCookieName(cookieSuffix), lang, {
    ...cookieOptions,
    expires,
    domain,
  });
}
